import { AUTH,  END_LOADING_AUTH, LOGOUT, SIGNUP, START_LOADING_AUTH } from "../constants/actionTypes"

const authReducer = (state = { authData: null, isLoading: false }, action) => {
    switch (action.type) {
        case AUTH:
            if (action.data.result?.username)
                localStorage.setItem('profile', JSON.stringify({ ...action?.data }))
            else
                localStorage.setItem('unverified_profile', JSON.stringify({ ...action?.data }))
            return { ...state, authData: action?.data };
        case SIGNUP:
        case LOGOUT:
            localStorage.clear();
            return { ...state, authData: null };
        case START_LOADING_AUTH:
            return { ...state, isLoading: true }
        case END_LOADING_AUTH:
            return { ...state, isLoading: false }
        default:
            return state;
    }
}

export default authReducer